<template>
  <div>
    <div class="content">
      <Header />
      <router-view />
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from '@/Mobile/Mobilecom/Header'
import Footer from '@/Mobile/Mobilecom/Footer'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data() {
    return {}
  },
  computed: {
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="less" scoped>

</style>
